// Minimal config for Pure Angular app
declare global {
    interface Window {
      SDM_ENVIRONMENT?: string;
      SdmGlobal?: typeof SdmGlobal;
      showLatestError?: () => void;
    }
}

export const SDM_ENVIRONMENT = (() => {
    const host = window.location.hostname;
    if (host === 'sdmweb.scanburapps.com') return 'production';
    if (host === 'localhost') return 'd0';
    return host.substring(0, host.indexOf('-'));
})();

export const SdmGlobal = {
    auth0Connection: () => {
        return (SDM_ENVIRONMENT === 'production' || SDM_ENVIRONMENT === 'u')
            ? 'sdmauth0db'
            : 'np-sdmauth0db';
    },
    auth0ClientId: () => {
        return (SDM_ENVIRONMENT === 'production' || SDM_ENVIRONMENT === 'u')
            ? '5WQOVJmSaT68OpDh87EUeNgxrDdQc9w0'
            : 'fPlCfMdcJ7VVaZAdJtk2tKpREg6EhaAj';
    },
    isMobile: () => {
        return /android|iphone|ipad|mobile|blackberry|iemobile/i.test(navigator.userAgent);
    },
    getEnv: () => {
        return SDM_ENVIRONMENT;
    },
    // Template validation functions (simplified)
    validateTemplateInput: (event: any) => {
        // Allow numbers, backspace, delete, tab, enter, decimal point
        const allowed = [8, 9, 13, 27, 46, 110, 190];
        const key = event.which || event.keyCode;
        if (allowed.indexOf(key) !== -1 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
            return true;
        }
        event.preventDefault();
        return false;
    },
    validateConditionInputForNegativeNumbersIsoCage: (event: any) => {
        const allowed = [8, 9, 13, 27, 46, 110, 190, 189, 109]; // Include minus sign
        const key = event.which || event.keyCode;
        if (allowed.indexOf(key) !== -1 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
            return true;
        }
        event.preventDefault();
        return false;
    },
    validateConditionInputForNegativeNumbersScantainer: (event: any) => {
        const allowed = [8, 9, 13, 27, 45, 46, 110, 190, 189, 109]; // Include minus sign
        const key = event.which || event.keyCode;
        if (allowed.indexOf(key) !== -1 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
            return true;
        }
        event.preventDefault();
        return false;
    },
    validateConditionInputForDecimalNumbers: (event: any) => {
        const allowed = [8, 9, 13, 27, 46, 110, 190]; // Include decimal point
        const key = event.which || event.keyCode;
        if (allowed.indexOf(key) !== -1 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
            return true;
        }
        event.preventDefault();
        return false;
    }
};

// Make SdmGlobal available globally
window.SdmGlobal = SdmGlobal;
window.SDM_ENVIRONMENT = SDM_ENVIRONMENT;